import enCompanyRoadmaps from './en';
import ruCompanyRoadmaps from './ru';

export default {
  en: {
    ...enCompanyRoadmaps,
  },
  ru: {
    ...ruCompanyRoadmaps,
  },
};
